import { useState, useEffect } from 'react';

const BREAKPOINTS = { spacious: 1440, desktop: 1200, laptop: 900, tablet: 700 };

function getMode(width) {
  if (width >= BREAKPOINTS.spacious) return 'spacious';
  if (width >= BREAKPOINTS.desktop) return 'desktop';
  if (width >= BREAKPOINTS.laptop) return 'laptop';
  if (width >= BREAKPOINTS.tablet) return 'tablet';
  return 'compact';
}

export function useResponsiveMode() {
  const [mode, setMode] = useState(() =>
    typeof window === 'undefined' ? 'desktop' : getMode(window.innerWidth)
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    let rafId = null;
    const onResize = () => {
      if (rafId !== null) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = null;
        setMode(getMode(window.innerWidth));
      });
    };
    window.addEventListener('resize', onResize, { passive: true });
    onResize();
    return () => {
      window.removeEventListener('resize', onResize);
      if (rafId !== null) window.cancelAnimationFrame(rafId);
    };
  }, []);

  return mode;
}
